import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Archive } from "lucide-react";

const ArchiveConfirmDialog = ({ 
  open, 
  onOpenChange, 
  onArchive, 
  onDelete,
  lottoName = "questo lotto"
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl" style={{ zIndex: 200 }}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Archive className="h-5 w-5 text-indigo-500" />
            Archivia lotto
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground py-2">
          Sei sicuro di voler archiviare <strong>{lottoName}</strong>? Potrai ripristinarlo in qualsiasi momento.
        </p>
        <DialogFooter className="flex gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
            Annulla
          </Button>
          <Button 
            onClick={() => { onArchive(); onOpenChange(false); }}
            className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white"
            data-testid="confirm-archive-btn"
          >
            Archivia
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ArchiveConfirmDialog;
